
import * as permissions from "../template/permissions"

import {
  customPermission
} from '../customization/permission'

export const getPermissionConfigs = () => {

  // default
  let {
    scopeIds: defaultScopeIds,
    scopeTypes: defaultScopeTypes,
    functionActionTypes: defaultFunctionActionTypes,
    functionTypes: defaultFunctionTypes,
    permissionConfigs: defaultPermissionConfigs
  } = permissions

  // console.log('customPermission', customPermission)

  let scopeIds = defaultScopeIds;
  let scopeTypes = defaultScopeTypes;
  let functionActionTypes = defaultFunctionActionTypes;
  let functionTypes = defaultFunctionTypes;
  let permissionConfigs = defaultPermissionConfigs

  // check the custom permission
  if (customPermission?.permissionConfigs) {

    let {
      scopeIds: customScopeIds,
      scopeTypes: customScopeTypes,
      functionTypes: customFunctionTypes,
      permissionConfigs: customPermissionConfigs
    } = customPermission

    // adding the all scope with custom field
    Object.keys(customScopeIds).forEach(i => {
      customScopeIds[i].isCustom = true
    })

    scopeIds = { ...scopeIds, ...customScopeIds }
    scopeTypes = { ...scopeTypes, ...customScopeTypes }
    functionTypes = { ...functionTypes, ...customFunctionTypes }
    permissionConfigs = { ...permissionConfigs, ...customPermissionConfigs }
  }

  let configs = {
    scopeIds,
    scopeTypes,
    functionActionTypes,
    functionTypes,
    permissionConfigs
  }

  // console.log('configs', configs)

  return configs
}